 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app~e2e93592": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app~e2e93592": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"chunk-commons~d939e436":"chunk-commons~d939e436","chunk-commons~f71cff67":"chunk-commons~f71cff67","chunk-commons~21833f8f":"chunk-commons~21833f8f","chunk-commons~447143dd":"chunk-commons~447143dd","home~21833f8f":"home~21833f8f","sentiment~21833f8f":"sentiment~21833f8f","user~6e76d53f":"user~6e76d53f","wonder~a0a3fe25":"wonder~a0a3fe25"}[chunkId]||chunkId) + "." + {"chunk-05a29214":"1bd9fd92","chunk-19b0cf18":"7c30625f","chunk-266544bb":"6c996c7f","chunk-2d0aab45":"714d2960","chunk-2d0cc1d9":"9673bc8b","chunk-2f45ca58":"7212ea58","chunk-2fd16595":"c1ba9604","chunk-37590406":"94b48fc2","chunk-3d370fbd":"56f21f71","chunk-4005715d":"36ce1d3c","chunk-43701c8e":"7fcfcddd","chunk-4fc4313d":"6db038de","chunk-5069aa76":"71f0680b","chunk-52b22ba5":"68aa9d1e","chunk-75fa76d9":"754a5df8","chunk-7aa1d62d":"3bb9be48","chunk-7f86371a":"1ea70933","chunk-b36c5926":"6556196c","chunk-commons~d939e436":"8de2a971","chunk-commons~f71cff67":"609f50d4","chunk-commons~21833f8f":"2c9917dd","chunk-commons~447143dd":"828d731f","chunk-03210516":"a48acdd4","chunk-058516b8":"c128a55e","chunk-078c5397":"a7704350","chunk-1549ede6":"2b1a421d","chunk-183a41d2":"9971cecc","chunk-19447ea9":"c88d8363","chunk-1c791567":"d0bff3c2","chunk-263a6f66":"81fa6691","chunk-278f15c2":"49761ed2","chunk-2d0a30ec":"7570fbbb","chunk-2d0c917a":"d2f59533","chunk-2d0da362":"4f83c51c","chunk-2d0daf52":"b2646cad","chunk-2d0e4810":"69cff49b","chunk-2d0efccf":"8b02ab94","chunk-2d207d1a":"08386c4d","chunk-2d2140d8":"6a567b94","chunk-2d217776":"c3ece7e1","chunk-2d226c7a":"3186550a","chunk-3576d672":"6156f152","chunk-4545ee2d":"fd40a00e","chunk-46a258dd":"eda42873","chunk-4a5f46a6":"0e02ff91","chunk-73e69c84":"7478f6e0","chunk-4c1f05b6":"32a03dd7","chunk-4fe9c630":"54861e0b","chunk-5531d079":"d5d7691e","chunk-576d49da":"e74441ee","chunk-5fa479c5":"025e559a","chunk-6627835c":"9dac0b44","chunk-76fab7fa":"4d3acabb","chunk-7b23f141":"acd59045","chunk-7e181d1d":"c218ddbf","chunk-a2103720":"5c7c0f8d","chunk-c5e4ae26":"b2ae2aa2","home~21833f8f":"4661b274","sentiment~21833f8f":"46a23bb4","user~6e76d53f":"c087053d","wonder~a0a3fe25":"d77c9f34","chunk-d36bd4fa":"f5075ea9","chunk-e0bc3344":"231291ae","chunk-4e213a26":"59ba4e13"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-05a29214":1,"chunk-19b0cf18":1,"chunk-266544bb":1,"chunk-2f45ca58":1,"chunk-37590406":1,"chunk-3d370fbd":1,"chunk-4005715d":1,"chunk-43701c8e":1,"chunk-4fc4313d":1,"chunk-52b22ba5":1,"chunk-75fa76d9":1,"chunk-7aa1d62d":1,"chunk-7f86371a":1,"chunk-b36c5926":1,"chunk-commons~f71cff67":1,"chunk-commons~21833f8f":1,"chunk-commons~447143dd":1,"chunk-03210516":1,"chunk-058516b8":1,"chunk-078c5397":1,"chunk-1549ede6":1,"chunk-183a41d2":1,"chunk-19447ea9":1,"chunk-1c791567":1,"chunk-263a6f66":1,"chunk-278f15c2":1,"chunk-3576d672":1,"chunk-4545ee2d":1,"chunk-46a258dd":1,"chunk-73e69c84":1,"chunk-4c1f05b6":1,"chunk-4fe9c630":1,"chunk-5531d079":1,"chunk-576d49da":1,"chunk-5fa479c5":1,"chunk-6627835c":1,"chunk-76fab7fa":1,"chunk-7b23f141":1,"chunk-7e181d1d":1,"chunk-a2103720":1,"chunk-c5e4ae26":1,"home~21833f8f":1,"sentiment~21833f8f":1,"user~6e76d53f":1,"wonder~a0a3fe25":1,"chunk-d36bd4fa":1,"chunk-e0bc3344":1,"chunk-4e213a26":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"chunk-commons~d939e436":"chunk-commons~d939e436","chunk-commons~f71cff67":"chunk-commons~f71cff67","chunk-commons~21833f8f":"chunk-commons~21833f8f","chunk-commons~447143dd":"chunk-commons~447143dd","home~21833f8f":"home~21833f8f","sentiment~21833f8f":"sentiment~21833f8f","user~6e76d53f":"user~6e76d53f","wonder~a0a3fe25":"wonder~a0a3fe25"}[chunkId]||chunkId) + "." + {"chunk-05a29214":"20d2b46c","chunk-19b0cf18":"3a86a2cb","chunk-266544bb":"2f2e42d6","chunk-2d0aab45":"31d6cfe0","chunk-2d0cc1d9":"31d6cfe0","chunk-2f45ca58":"3c8c4dca","chunk-2fd16595":"31d6cfe0","chunk-37590406":"d9b759b3","chunk-3d370fbd":"064cab12","chunk-4005715d":"f96e9b7e","chunk-43701c8e":"d04338fa","chunk-4fc4313d":"80994280","chunk-5069aa76":"31d6cfe0","chunk-52b22ba5":"e9580f07","chunk-75fa76d9":"0f317b67","chunk-7aa1d62d":"fb53adac","chunk-7f86371a":"0ba3e99d","chunk-b36c5926":"1d2909f2","chunk-commons~d939e436":"31d6cfe0","chunk-commons~f71cff67":"33cb4d0d","chunk-commons~21833f8f":"483e6ad3","chunk-commons~447143dd":"5061d61f","chunk-03210516":"78718bd2","chunk-058516b8":"0fe3e47d","chunk-078c5397":"5b54aec7","chunk-1549ede6":"b79eb2bf","chunk-183a41d2":"087f1973","chunk-19447ea9":"eefe5e95","chunk-1c791567":"2c606da0","chunk-263a6f66":"0a184d0d","chunk-278f15c2":"5c5c2664","chunk-2d0a30ec":"31d6cfe0","chunk-2d0c917a":"31d6cfe0","chunk-2d0da362":"31d6cfe0","chunk-2d0daf52":"31d6cfe0","chunk-2d0e4810":"31d6cfe0","chunk-2d0efccf":"31d6cfe0","chunk-2d207d1a":"31d6cfe0","chunk-2d2140d8":"31d6cfe0","chunk-2d217776":"31d6cfe0","chunk-2d226c7a":"31d6cfe0","chunk-3576d672":"a64067e4","chunk-4545ee2d":"43d684f4","chunk-46a258dd":"d2558648","chunk-4a5f46a6":"31d6cfe0","chunk-73e69c84":"568956ce","chunk-4c1f05b6":"bbb450a4","chunk-4fe9c630":"b94e33b5","chunk-5531d079":"939147fd","chunk-576d49da":"0bfcbfd3","chunk-5fa479c5":"503fdf5f","chunk-6627835c":"1463a986","chunk-76fab7fa":"40015950","chunk-7b23f141":"166dc5d7","chunk-7e181d1d":"e3dcf7c2","chunk-a2103720":"17e83b19","chunk-c5e4ae26":"f2752c87","home~21833f8f":"7bb81c9b","sentiment~21833f8f":"ffccecf4","user~6e76d53f":"9a17f1c6","wonder~a0a3fe25":"da09e590","chunk-d36bd4fa":"e18b6095","chunk-e0bc3344":"0aa120c4","chunk-4e213a26":"9916460c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors~d939e436"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
